/* eslint-disable camelcase */
/* eslint-disable no-console */

import { makeAutoObservable, runInAction } from 'mobx';

import { API, APIRoutes } from '@api';
import queryString from 'query-string';
import { routerStore } from '@stores';
import routes from '@routes';

export class TracksHistoryStore {
  isLoading = false;

  albums = [];

  trackHistories = [];

  meta = null;

  perPage = 24;

  page = 1;

  totalPages = null;

  error = null;

  order = { by: 'directory_name', dir: 'desc' };

  constructor() {
    makeAutoObservable(this);
  }

  getTracksHistory = async () => {
    try {
      this.isLoading = true;

      const { p: page } = queryString.parse(routerStore.location.search);

      runInAction(() => {
        this.page = page || 1;
      });

      const {
        data: { track_histories, meta },
      } = await API.get(APIRoutes.TRACKS_HISTORY(page, this.perPage));

      runInAction(() => {
        this.trackHistories = track_histories;
        this.meta = meta;
        this.totalPages = Math.ceil(this.meta.total_count / this.perPage);
      });
    } catch (error) {
      console.warn(error);
      this.error = error;
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  switchPage = page => {
    const params = routerStore.location.search;
    const queryParams = queryString.parse(params);
    queryParams.p = page + 1;
    routerStore.push(
      `${routes.tracksHistory}?${queryString.stringify(queryParams)}`,
    );
  };
}

export default new TracksHistoryStore();
